import * as React from 'react'

/**
 * ChartEmpty — consistent placeholder shown whenever a chart has no data, so no
 * chart/bar ever renders as a blank area. Sized to the chart's height to keep the
 * surrounding layout from collapsing.
 */
export default function ChartEmpty({ height = 350, message = 'No data available' }) {
  return (
    <div
      style={{
        height: typeof height === 'number' ? `${height}px` : height,
        minHeight: '120px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        color: '#919EAB',
      }}
    >
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#C4CDD5" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 3v18h18" />
        <rect x="7" y="12" width="3" height="5" />
        <rect x="12" y="8" width="3" height="9" />
        <rect x="17" y="14" width="3" height="3" />
      </svg>
      <span style={{ fontSize: '13px', fontWeight: 500, fontFamily: 'inherit' }}>{message}</span>
    </div>
  )
}
